import React, { useState, useContext, useEffect } from "react";
import { LoadingSpinner } from "../utils/LoadingSpinner";
import { Link, Redirect} from "react-router-dom";

import UserPool from "../UserPool";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
import { AccountContext } from "../User/Account";

export const SignUp = () => {
	const [username, setUsername] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [errorLogin, setErrorLogin] = useState("")
	const [successfulSignUp, setSuccessfulSignUp] = useState(false)

	const [isLoading, setIsLoading] = React.useState(false);

	
	const {isAuthenticated, SignUp, Auth} = useContext(AccountContext);

	const onLogInClick = async (e: React.FormEvent<EventTarget>) => {
		e.preventDefault();
		setIsLoading(true);


		SignUp(username, password, email).then((data: any) => {
			console.log("Signed Up!", data)
			setSuccessfulSignUp(true)
			setIsLoading(false)
		}
		).catch((err: any) => {
			console.error("Failed to Signup", err);
			setErrorLogin(err.message)
			setIsLoading(false)
		});

		/*const emailAttribute = new CognitoUserAttribute({
			Name: "email",
			Value: email,
		});

		console.log(password);
		UserPool.signUp(
			username,
			password,
			[emailAttribute],
			[],
			(err, result: undefined | any) => {
				if (err) {
					alert(err.message || JSON.stringify(err));
					return;
				}
				let cognitoUser = result.user;
				console.log("user name is " + cognitoUser.getUsername());
			}
		);*/
		setIsLoading(false);
	};

	if (isLoading) {
		return <LoadingSpinner></LoadingSpinner>;
	}

	return (
		<div className="container my-5">
			<div className='btn btn-danger' style={{width: "100%", visibility: errorLogin !== "" ? 'visible': 'hidden'}}>{errorLogin}</div>
			<form>
				<div className="form-group mt-5">
					<label htmlFor="exampleInputEmail1">Username</label>
					<input
						onChange={(e) => setUsername(e.target.value)}
						type="text"
						className="form-control mb-3"
						id="exampleInputEmail1"
						aria-describedby="emailHelp"
						placeholder="Enter Username"
					/>
				</div>
				<div className="form-group">
					<label htmlFor="exampleInputPassword1">Email</label>
					<input
						onChange={(e) => setEmail(e.target.value)}
						type="email"
						className="form-control mb-3"
						id="exampleInputPassword1"
						placeholder="Enter Email"
					/>
				</div>
				<div className="form-group">
					<label htmlFor="exampleInputPassword1">Password</label>
					<input
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						className="form-control mb-3"
						id="exampleInputPassword1"
						placeholder="Enter Password"
					/>
				</div>
				<div className="row g-0">
					<div className="col-md-7">
						{/* Desktop Image */}
						<button
							disabled={!username || !password || !email}
							onClick={onLogInClick}
							className="d-lg-flex btn btn-danger"
						>
							Sign Up
						</button>
					</div>
				</div>
			</form>

			<div className="">
				<div>
					<hr />

					<div className="col-md-3">
						<button className="d-lg-flex justify-content-center align-items-center btn btn-danger mb-5">
							<Link to="/login" className="text-white">
								Already have an account?
							</Link>
						</button>
					</div>
				</div>
				{successfulSignUp ? <Redirect to="/login"></Redirect> : null}
				{isAuthenticated ? <Redirect to="/"></Redirect> : null}
			</div>
		</div>
	);
};
